<template>
    <li class="navi-item mt-1">
        <div class="navi-link py-2 px-4 pr-10 cursor-pointer"
             :class="{'opacity-50': disabled, 'active': active}"
             @click="selectMenuEntry"
        >
            <span class="navi-icon mr-2">
                <i :class="icon"/>
            </span>
            <span class="navi-text text-nowrap" :class="{'font-weight-bolder': active}">
                {{ name }}
            </span>
        </div>
    </li>
</template>

<script>

export default {
    props: {
        icon: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        active: Boolean,
        disabled: Boolean,
    },

    methods: {
        selectMenuEntry() {
            if (this.disabled) {
                return;
            }

            this.$emit('select')
        }
    },
}
</script>

<style>
.navi-icon {
    width: 16px !important;
    text-align: center;
}
</style>
